/*
 * App constants
 */

export const WINDOW_RESIZE = 'Dyzio/App/WINDOW_RESIZE';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/